import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import * as echarts from 'echarts'
import Moment from 'moment'
import api from './api'
import store from './store/index'
import preventClick  from './utils/clickOnceAtime'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import 'element-ui/lib/theme-chalk/index.css'
import "./common/common.css"
import './assets/font/iconfont.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueClipBoard from 'vue-clipboard2'
import VueAMap from 'vue-amap';
import Vue2OrgTree from 'vue2-org-tree'
Vue.use(Vue2OrgTree)
Vue.use(VueClipBoard)

Vue.use(Vant);
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp']; 
// import 'vue.config.js'
// require("./mock/mock.js")
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);
Viewer.setDefaults({
  // 是否启用inline模式，
      //true时表示预览图层在父元素内，
      //false时表示预览图层在顶层父元素上，即图层覆盖整个页面
  inline: false, 
  button: true, 
  navbar: true, 
  title: false, 
  toolbar: true, 
  tooltip: true, 
  fullscreen: true, 
  loading: true, 
  loop: true, 
  movable: true, 
  zoomable: true, 
  rotatable: true, 
  scalable: false, 
  toggleOnDblclick: true, 
  transition: true, 
  keyboard: true, 
  zoomRatio: 0.1,
  minZoomRatio: 0.1, 
  maxZoomRatio: 10,
})
Vue.use(preventClick)
Vue.use(ElementUI)
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
  // 高德的key
  key: '019a2508d25e390f01e67307d39509dc',
  // 插件集合
  plugin: [
    'AMap.CircleEditor',// 圆形编辑器插件
    "AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
    "AMap.Geocoder", // 地理编码与逆地理编码服务，用于地址描述与坐标间的相互转换
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.CitySearch",
    'AMap.Marker',
    'AMap.ToolBar',
    'AMap.MapType', 
  ],
//   plugin: ['AMap.Geolocation', 'AMap.Marker', 'AMap.Geocoder', 'AMap.ToolBar', 'AMap.MapType',   "AMap.Autocomplete",   "AMap.PlaceSearch",
//  "AMap.CitySearch",],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4',
});
//高德的安全密钥
window._AMapSecurityConfig = {
  securityJsCode: '526bd2695d0e233f0c388601210b14d9',
}
// 将api挂载到vue的原型上
Vue.prototype.$video = Video
Vue.prototype.$api = api;
Vue.prototype.$echarts = echarts
Vue.prototype.moment = Moment
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp']; 
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js